import ArrayInput from "./ArrayInput";
import Checkbox from "./Checkbox";
import Choices from "./Choices";
import Code from "./Code";
import ColorInput from "./ColorInput";
import Emoji from "./Emoji";
import FlatArrayInput from "./FlatArrayInput";
import MultilingualTextInput from "./MultinlingualTextInput";
import Nested from "./Nested";
import TextAreaInput from "./TextAreaInput";
import TextInput from "./TextInput";

const components = {
  nested: {
    component: (parameters) => Nested(parameters),
    default: "",
  },
  text: {
    component: (parameters) => TextInput(parameters),
    default: "",
  },
  textarea: {
    component: (parameters) => TextAreaInput(parameters),
    default: "",
  },
  code: {
    component: (parameters) => Code(parameters),
    default: "",
  },
  multilingualText: {
    component: (parameters) => MultilingualTextInput(parameters),
    default: {},
  },
  array: {
    component: (parameters) => ArrayInput(parameters),
    default: [],
    hasElemModel: true,
  },
  flatArray: {
    component: (parameters) => FlatArrayInput(parameters),
    default: [],
    hasElemModel: true,
  },
  choice: {
    component: (parameters) => Choices(parameters),
    default: "",
  },
  boolean: {
    component: (parameters) => Checkbox(parameters),
    default: "",
  },
  color: {
    component: (parameters) => ColorInput(parameters),
    default: "blue",
  },
  emoji: {
    component: (parameters) => Emoji(parameters),
    default: "",
  },

  /*ElementList: {
        element: ElementList,
        parameters: {
            question: {
                label: "Question :",
                type: "multilingual_text",
                default: {"en": ""}
            },
            elements: {
                label: "Elements :",
                type: "array",
                default: [],
                elemModel: {
                    key: {
                        label: "Nom :",
                        type: "multilingual_text",
                        default: ""
                    },
                    value: {
                        label: "Valeur :",
                        type: "text",
                        default: ""
                    }
                }
            }
        }
    },*/
};

export default components;
